import React, { useState } from "react";
import { Container, Row, Col, Collapse } from "react-bootstrap";
import stepScreen1 from "assets/images/step-screen-1.png";
import stepScreen2 from "assets/images/step-screen-2.png";
import stepScreen3 from "assets/images/step-screen-3.png";
import stepScreen4 from "assets/images/step-screen-4.png";
import HeroSection from "components/common/sections/HeroSection";
import TryDemoSection from "components/common/sections/TryDemoSection";
import FAQSection from "components/common/sections/FAQSection";
import "./HowItWorks.css";

function HowItWorks() {
  const [expandedTextOrder, setExpandedTextOrder] = useState(1);
  const [showSteps, setShowSteps] = useState(false);

  return (
    <>
      {/* Hero section */}
      <HeroSection setShowSteps={setShowSteps} />

      {/* How to DCA section */}
      <section id="how-to-dca-section">
        <Container>
          <Row className="d-flex justify-content-center py-3">
            <Col sm={12} lg={8} className="text-center my-auto mb-lg-auto px-4">
              <h1>How to Fill Out SMART SIP Form:</h1>
              <p>
                In this section, we will walk you through the entire SMART SIP
                form, explaining the purpose and significance of each field. By
                the time you finish reading, you'll have a clear understanding
                of how to complete the form and how your choices impact your
                investment journey.
              </p>
            </Col>
            <Col sm={12} lg={10} xl={8} className="mb-2 mb-lg-4">
              <div className="mt-4">
                <h4
                  style={{
                    clear: "both",
                    borderBottomStyle: "groove",
                    paddingBottom: "20px",
                    borderWidth: "1px",
                  }}
                >
                  Country
                  <i
                    className={`bi bi-arrow-${
                      expandedTextOrder === 1 ? "up" : "down"
                    }-circle button-expand`}
                    onClick={() =>
                      setExpandedTextOrder(expandedTextOrder === 1 ? 0 : 1)
                    }
                  ></i>
                </h4>
                <Collapse in={expandedTextOrder === 1}>
                  <div id="collapse-text">
                    <p style={{ color: "#03001C99" }}>
                      The first step in filling out the SMART SIP form is to
                      select the country where you intend to invest. Typically,
                      this will be the country in which you reside or the
                      country where your broker permits you to invest.
                    </p>
                    <p style={{ color: "#03001C99" }}>
                      The choice of country is a crucial starting point, as it
                      determines the regulatory framework, tax implications, and
                      the specific stocks/ETF's available to you.
                    </p>
                    <p style={{ color: "#03001C99" }}>
                      Here's what you need to consider when choosing your
                      investment country:
                    </p>
                    <ul style={{ color: "#03001C99" }}>
                      <li>
                        <strong>Residence:</strong> Select the country where you
                        currently reside or are a citizen. This is often the
                        most straightforward choice.
                      </li>
                      <li>
                        <strong>Broker Restrictions:</strong> Ensure that your
                        chosen broker supports investments in the selected
                        country. Some brokers may have limitations on
                        international investments.
                      </li>
                      {/*<li><strong>Taxation:</strong> Understand the tax laws and regulations of the chosen country, as*/}
                      {/*  they can impact your investment returns and obligations.*/}
                      {/*</li>*/}
                      <li>
                        <strong>Stock/ETF Availability:</strong> Different
                        countries offer varying stocks and ETF's.
                      </li>
                    </ul>
                  </div>
                </Collapse>
              </div>
              <div className="mt-4">
                <h4
                  style={{
                    clear: "both",
                    borderBottomStyle: "groove",
                    paddingBottom: "20px",
                    borderWidth: "1px",
                  }}
                >
                  Stock/ETF:
                  <i
                    className={`bi bi-arrow-${
                      expandedTextOrder === 2 ? "up" : "down"
                    }-circle button-expand`}
                    onClick={() =>
                      setExpandedTextOrder(expandedTextOrder === 2 ? 0 : 2)
                    }
                  ></i>
                </h4>
                <Collapse in={expandedTextOrder === 2}>
                  <div id="collapse-text">
                    <p style={{ color: "#03001C99" }}>
                      Choose from a wide range of stocks and Exchange-Traded
                      Funds (ETFs).
                    </p>
                    <p style={{ color: "#03001C99" }}>
                      Simply enter the name or symbol of the stock or ETF you're
                      interested in, and our platform will help you find it
                      quickly.
                    </p>
                    <p style={{ color: "#03001C99" }}>
                      Remember to conduct your research and consider your
                      investment strategy carefully before making your
                      selection.
                    </p>
                  </div>
                </Collapse>
              </div>
              <div className="mt-4">
                <h4
                  style={{
                    clear: "both",
                    borderBottomStyle: "groove",
                    paddingBottom: "20px",
                    borderWidth: "1px",
                  }}
                >
                  Percent Down
                  <i
                    className={`bi bi-arrow-${
                      expandedTextOrder === 3 ? "up" : "down"
                    }-circle button-expand`}
                    onClick={() =>
                      setExpandedTextOrder(expandedTextOrder === 3 ? 0 : 3)
                    }
                  ></i>
                </h4>
                <Collapse in={expandedTextOrder === 3}>
                  <div id="collapse-text">
                    <p style={{ color: "#03001C99" }}>
                      This percentage represents a price drop from the stock's
                      current value before you make your purchase. If you would
                      like to purchase when the stock price drops by 5% enter 5.
                    </p>
                    <p style={{ color: "#03001C99" }}>
                      For example, if you enter "10" the system will
                      automatically purchase the stock when the price drops by
                      10%. And start monitoring for the next 10% drop to
                      purchase again.
                    </p>
                    {/*<p style={{color: "#03001C99"}}></p>*/}
                  </div>
                </Collapse>
              </div>
              <div className="mt-4">
                <h4
                  style={{
                    clear: "both",
                    borderBottomStyle: "groove",
                    paddingBottom: "20px",
                    borderWidth: "1px",
                  }}
                >
                  Quantity per Order
                  <i
                    className={`bi bi-arrow-${
                      expandedTextOrder === 4 ? "up" : "down"
                    }-circle button-expand`}
                    onClick={() =>
                      setExpandedTextOrder(expandedTextOrder === 4 ? 0 : 4)
                    }
                  ></i>
                </h4>
                <Collapse in={expandedTextOrder === 4}>
                  <div id="collapse-text">
                    <p style={{ color: "#03001C99" }}>
                      Specify the number of shares or units you wish to purchase
                      when the stock's price reaches the percentage down you
                      defined in the previous field.
                    </p>
                    <p style={{ color: "#03001C99" }}>
                      For instance, if you set the "Percent Down" to 5% and
                      specify "100" as the "Quantity per Order," it means that
                      when the stock's price drops by 5% or more, the system
                      will purchase 100 shares or units of that stock at one
                      order. Don't worry if you don't have enough funds for the
                      purchase in your account the system will lower the
                      quantity and notify you.
                    </p>
                    <p style={{ color: "#03001C99" }}>
                      We will be setting up how many total shares we want to buy
                      in the next field.
                    </p>
                  </div>
                </Collapse>
              </div>
              <div className="mt-4">
                <h4
                  style={{
                    clear: "both",
                    borderBottomStyle: "groove",
                    paddingBottom: "20px",
                    borderWidth: "1px",
                  }}
                >
                  Maximum Quantity
                  <i
                    className={`bi bi-arrow-${
                      expandedTextOrder === 5 ? "up" : "down"
                    }-circle button-expand`}
                    onClick={() =>
                      setExpandedTextOrder(expandedTextOrder === 5 ? 0 : 5)
                    }
                  ></i>
                </h4>
                <Collapse in={expandedTextOrder === 5}>
                  <div id="collapse-text">
                    <p style={{ color: "#03001C99" }}>
                      In the "Maximum Quantity" field, you define the total
                      number of shares or units you want to purchase for the
                      particular stock you've chosen.
                    </p>
                    <p style={{ color: "#03001C99" }}>
                      Let's say you've set the "Quantity per Order" to 100
                      shares and a "Percent Down" of 5%. When the stock falls by
                      5%, one order of 100 shares will be bought. If the price
                      continues to drop and another 5% down is reached, another
                      100 shares will be bought, and so on. To avoid excessive
                      purchases and keep your ideal allocation in check, you set
                      a maximum quantity.
                    </p>
                    <p style={{ color: "#03001C99" }}>
                      For example, if you decide that your maximum quantity is
                      500 shares, the system will automatically stop purchasing
                      shares once you reach that limit. This ensures that your
                      investment remains within your desired allocation for that
                      stock.
                    </p>
                  </div>
                </Collapse>
              </div>
              <div className="mt-4">
                <h4
                  style={{
                    clear: "both",
                    borderBottomStyle: "groove",
                    paddingBottom: "20px",
                    borderWidth: "1px",
                  }}
                >
                  Total Amount
                  <i
                    className={`bi bi-arrow-${
                      expandedTextOrder === 6 ? "up" : "down"
                    }-circle button-expand`}
                    onClick={() =>
                      setExpandedTextOrder(expandedTextOrder === 6 ? 0 : 6)
                    }
                  ></i>
                </h4>
                <Collapse in={expandedTextOrder === 6}>
                  <div id="collapse-text">
                    <p style={{ color: "#03001C99" }}>
                      The "Total Amount" field allows you to set a limit on the
                      total amount you want to invest in a particular stock.
                      <br />
                    </p>
                    <p style={{ color: "#03001C99" }}>
                      Here's how it works:
                      <br /> Let's say you have an ideal allocation of 500,000
                      for a stock, but due to the maximum units defined in the
                      previous field, the total investment might exceed that
                      amount, for example, 600,000. <br />
                      By setting the "Total Amount" to 500,000, the system will
                      automatically stop purchasing shares when the total
                      invested amount reaches this limit.
                    </p>
                    <p style={{ color: "#03001C99" }}>
                      This feature helps you maintain your desired allocation to
                      individual stocks/ETF's and ensures that you invest the
                      amount you have decided, enhancing your control over your
                      investment portfolio.
                    </p>
                  </div>
                </Collapse>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* End */}

      {/* Invest Wisely section */}
      <section id="invest-section">
        <Container>
          <Row className="d-flex justify-content-center py-3">
            <Col className="col-12 text-center my-auto mb-lg-auto">
              <h3 className="mb-4 mt-4">How it works?</h3>
              <h1 className="mb-5">INVEST WISELY</h1>
            </Col>
          </Row>
        </Container>
      </section>
      {/* End */}

      {/* Step 1 section */}
      <section id="step-1">
        <Container fluid className="mb-5 mt-5 text-center text-lg-start">
          <Row>
            <Col sm={1} lg={2} className="d-none d-lg-block"></Col>
            <Col
              sm={12}
              lg={5}
              className="d-flex align-items-center justify-content-center text-left p-5 bg-white"
            >
              <div>
                <h4 style={{ color: "#000000aa", marginBottom: "10px" }}>
                  STEP 1
                </h4>
                <h3>Fill in SMART SIP Form</h3>
                <p style={{ color: "#000000cc", marginBottom: "30px" }}>
                  Click the Add DCA button on the Dashboard and fill in the
                  form.
                  <br />
                  Hooray! You will not have to monitor this stock ever again.
                </p>
                <h4 style={{ display: "inline-flex" }}>
                  Read more
                  <i
                    className="bi bi-arrow-right-circle ml-4"
                    style={{ fontSize: "1.5rem", marginLeft: "15px" }}
                  ></i>
                </h4>
              </div>
            </Col>
            <Col sm={12} lg={5} className="px-0 d-flex flex-column bg-white">
              <div className="flex-grow-1">
                <img className="img-fluid" src={stepScreen1} alt="" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* End */}

      {/* Step 2 section */}
      <section id="step-2">
        <Container fluid className="mb-5 mt-5 text-center text-lg-start">
          <Row>
            <Col
              sm={12}
              lg={5}
              className="text-center order-2 order-lg-1 d-flex flex-column bg-white"
            >
              <div className="flex-grow-1">
                <img className="img-fluid" src={stepScreen2} alt="" />
              </div>
            </Col>
            <Col
              sm={12}
              lg={5}
              className="d-flex align-items-center justify-content-center order-1 order-lg-2 text-left p-5 bg-white"
            >
              <div>
                <h4 style={{ color: "#000000aa", marginBottom: "10px" }}>
                  STEP 2
                </h4>
                <h3>System monitors</h3>
                <p style={{ color: "#000000cc", marginBottom: "30px" }}>
                  We will monitor all the SMART SIP instructions you have
                  provided.
                  <br />
                  Why monitor 1 stock or ETF when we can monitor 100's, just
                  waiting for the right opportunity to invest.
                </p>
                <h4 style={{ display: "inline-flex" }}>
                  Read more
                  <i
                    className="bi bi-arrow-right-circle ml-4"
                    style={{ fontSize: "1.5rem", marginLeft: "15px" }}
                  ></i>
                </h4>
              </div>
            </Col>
            <Col sm={1} lg={2} className="d-none d-lg-block order-3"></Col>
          </Row>
        </Container>
      </section>
      {/* End */}

      {/* Step 3 section */}
      <section id="step-3">
        <Container fluid className="mb-5 mt-5 text-center text-lg-start">
          <Row>
            <Col sm={1} lg={2} className="d-none d-lg-block"></Col>
            <Col
              sm={12}
              lg={5}
              className="d-flex align-items-center justify-content-center text-left p-5 bg-white"
            >
              <div>
                <h4 style={{ color: "#000000aa", marginBottom: "10px" }}>
                  STEP 3
                </h4>
                <h3>Price reached/Triggers</h3>
                <p style={{ color: "#000000cc", marginBottom: "30px" }}>
                  The system keeps an eye on prices and sends out alerts if your
                  instructed price is reached.
                </p>
                <h4 style={{ display: "inline-flex" }}>
                  Read more
                  <i
                    className="bi bi-arrow-right-circle ml-4"
                    style={{ fontSize: "1.5rem", marginLeft: "15px" }}
                  ></i>
                </h4>
              </div>
            </Col>
            <Col sm={12} lg={5} className="px-0 d-flex flex-column bg-white">
              <div className="flex-grow-1">
                <img className="img-fluid" src={stepScreen3} alt="" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* End */}

      {/* Step 4 section */}
      <section id="step-4">
        <Container fluid className="mb-5 mt-5 text-center text-lg-start">
          <Row>
            <Col
              sm={12}
              lg={5}
              className="text-center order-2 order-lg-1 d-flex flex-column bg-white"
            >
              <div className="flex-grow-1">
                <img
                  className="img-fluid"
                  style={{ maxHeight: "320px" }}
                  src={stepScreen4}
                  alt=""
                />
              </div>
            </Col>
            <Col
              sm={12}
              lg={5}
              className="d-flex align-items-center justify-content-center order-1 order-lg-2 text-left p-5 bg-white"
            >
              <div>
                <h4 style={{ color: "#000000aa", marginBottom: "10px" }}>
                  STEP 4
                </h4>
                <h3>Automatic Invest or Get Alert</h3>
                <p style={{ color: "#000000cc", marginBottom: "30px" }}>
                  If an instruction is triggered, we can invest for you(if you
                  have added broker). If there is a shortage of funds, the
                  system will automatically adjust the quantity and notify you.
                  <br />
                  Or send you an alert to purchase if you prefer the harder
                  option.
                </p>
                <h4 style={{ display: "inline-flex" }}>
                  Read more
                  <i
                    className="bi bi-arrow-right-circle ml-4"
                    style={{ fontSize: "1.5rem", marginLeft: "15px" }}
                  ></i>
                </h4>
              </div>
            </Col>
            <Col sm={1} lg={2} className="d-none d-lg-block order-3"></Col>
          </Row>
        </Container>
      </section>
      {/* End */}

      {/* FAQ section */}
      <FAQSection />

      {/* Try CTA section */}
      <TryDemoSection showSteps={showSteps} setShowSteps={setShowSteps} />
    </>
  );
}

export default HowItWorks;
